module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-checkbox-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b70a8f36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/src/checkbox-group.vue
// module id = 676
// module chunks = 0